/* The Collector Edit — Shipping Protection (tiered, removable).
   - A single checkbox row near the checkout button. The protection line item is
     hidden from the cart list via CSS; only the checkbox is shown.
   - The "?" opens an INLINE info panel inside the drawer (not a full-screen modal).
   - After any add/remove we dispatch Horizon's 'cart:update' so the drawer
     re-renders (fixes "uncheck doesn't remove" / stale totals).
   - A MutationObserver re-injects the row whenever the drawer re-renders. */
(function () {
  'use strict';

  var SP = {
    variants: { 5: '48628077789367', 10: '48628077822135', 20: '48628077854903', 25: '48628077887671', 35: '48628077920439', 40: '48628077953207' },
    variantIds: ['48628077789367', '48628077822135', '48628077854903', '48628077887671', '48628077920439', '48628077953207'],
    busy: false,
    lastAdd: 0,
    lastCart: null,
    optedOut: function () { try { return sessionStorage.getItem('ce_sp_optout') === '1'; } catch (e) { return false; } },
    setOptOut: function (on) { try { on ? sessionStorage.setItem('ce_sp_optout', '1') : sessionStorage.removeItem('ce_sp_optout'); } catch (e) {} },

    feeForCart: function (t) { return t < 500 ? 5 : t < 1000 ? 10 : t < 2300 ? 20 : t < 3500 ? 25 : t < 4500 ? 35 : 40; },
    isProt: function (it) { return (it.title || '').indexOf('Shipping Protection') > -1 || this.variantIds.indexOf(String(it.variant_id)) > -1; },
    subtotalNoProt: function (c) { var t = 0; c.items.forEach(function (i) { if (!SP.isProt(i)) t += i.final_line_price; }); return t / 100; },
    realCount: function (c) { return c.items.filter(function (i) { return !SP.isProt(i); }).length; },
    protIn: function (c) { return c.items.find(function (i) { return SP.isProt(i); }); },
    allProt: function (c) { return c.items.filter(function (i) { return SP.isProt(i); }); },

    getCart: function () { return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); },
    add: function (id) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }) }); },
    remove: function (key) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }); },
    removeAll: function (cart) {
      var self = this, chain = Promise.resolve();
      this.allProt(cart).forEach(function (p) { chain = chain.then(function () { return self.remove(p.key); }); });
      return chain;
    },

    // tell Horizon to re-render cart sections (no `sections` => components renderSection fresh)
    notify: function (cart) { try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ce-sp', data: {} } })); } catch (e) {} },

    rowHTML: function (fee, checked) {
      return '' +
        '<div class="ce-sp-wrapper" id="ce-shipping-protection">' +
          '<div class="ce-sp-row">' +
            '<label class="ce-sp-label">' +
              '<input type="checkbox" id="ce-sp-checkbox"' + (checked ? ' checked' : '') + '>' +
              '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
              '<span>Shipping Protection</span>' +
              '<button type="button" class="ce-sp-help" aria-label="About shipping protection">?</button>' +
            '</label>' +
            '<span class="ce-sp-price">$' + fee.toFixed(2) + '</span>' +
          '</div>' +
        '</div>';
    },
    modalHTML: function (fixed) {
      return '' +
        '<div class="ce-sp-modal-overlay' + (fixed ? ' ce-sp-modal-overlay--fixed' : '') + '" id="ce-sp-modal">' +
          '<div class="ce-sp-modal">' +
            '<button type="button" class="ce-sp-modal-close" aria-label="Close">&times;</button>' +
            '<h3>Protect Your Order</h3>' +
            '<p>Covers your order if the carrier loses your package in transit, up to $3,000 of declared value. Unchecking means The Collector Edit is not responsible for a package lost in transit.</p>' +
            '<a href="/pages/shipping-protection" class="ce-sp-learn-more" target="_blank" rel="noopener">Learn more</a>' +
          '</div>' +
        '</div>';
    },
    // open the info modal OVER the drawer (inside the drawer dialog so it overlays just the cart)
    showModal: function () {
      var host = document.querySelector('cart-drawer-component dialog') || document.querySelector('cart-drawer-component') || document.querySelector('.cart-drawer');
      var fixed = false;
      if (!host) { host = document.body; fixed = true; }
      var existing = document.getElementById('ce-sp-modal');
      if (existing) existing.remove();
      host.insertAdjacentHTML('beforeend', this.modalHTML(fixed));
      var modal = document.getElementById('ce-sp-modal');
      requestAnimationFrame(function () { if (modal) modal.classList.add('active'); });
    },

    findTarget: function () {
      return document.querySelector(
        'cart-drawer-component [name="checkout"], .cart-drawer [name="checkout"], #cart-drawer [name="checkout"], .cart-drawer__footer [name="checkout"], .cart__ctas [name="checkout"], [name="checkout"]'
      );
    },
    ensureUI: function () {
      var c = this.lastCart;
      if (!c || this.realCount(c) === 0) return;
      if (document.getElementById('ce-shipping-protection')) return;
      var target = this.findTarget();
      if (!target) return;
      target.insertAdjacentHTML('beforebegin', this.rowHTML(this.feeForCart(this.subtotalNoProt(c)), !!this.protIn(c)));
    },
    syncRow: function () {
      var c = this.lastCart; if (!c) return;
      var row = document.getElementById('ce-shipping-protection'); if (!row) return;
      var txt = '$' + this.feeForCart(this.subtotalNoProt(c)).toFixed(2);
      var p = row.querySelector('.ce-sp-price'); if (p && p.textContent !== txt) p.textContent = txt;
      var cb = document.getElementById('ce-sp-checkbox');
      if (cb && document.activeElement !== cb) cb.checked = !!this.protIn(c);
    },

    refresh: function (autoAdd) {
      var self = this;
      return this.getCart().then(function (c) {
        self.lastCart = c;
        self.ensureUI(); self.syncRow();
        if (autoAdd && self.realCount(c) > 0 && !self.protIn(c) && !self.busy && !self.optedOut()) {
          self.busy = true;
          return self.add(self.variants[self.feeForCart(self.subtotalNoProt(c))])
            .then(function () { return self.getCart(); })
            .then(function (c2) { self.lastCart = c2; self.syncRow(); self.notify(c2); })
            .finally(function () { self.busy = false; });
        }
      }).catch(function () {});
    },

    reconcile: function () {
      if (this.busy) return;
      var self = this; this.busy = true;
      this.getCart().then(function (c) {
        self.lastCart = c;
        var prots = self.allProt(c);
        var changed = false;
        var chain = Promise.resolve();
        if (self.realCount(c) === 0) {
          self.setOptOut(false);
          if (prots.length) { changed = true; chain = self.removeAll(c); }
        } else {
          var correctId = self.variants[self.feeForCart(self.subtotalNoProt(c))];
          var correct = prots.find(function (p) { return String(p.variant_id) === correctId; });
          var wrong = prots.filter(function (p) { return String(p.variant_id) !== correctId; });
          wrong.forEach(function (p) { changed = true; chain = chain.then(function () { return self.remove(p.key); }); });
          if (!correct && wrong.length > 0) { changed = true; chain = chain.then(function () { return self.add(correctId); }); }
        }
        return chain.then(function () { return self.getCart(); }).then(function (c2) {
          self.lastCart = c2; self.ensureUI(); self.syncRow(); if (changed) self.notify(c2);
        });
      }).finally(function () { self.busy = false; });
    }
  };

  // ---- delegated events (survive drawer re-renders) ----
  document.addEventListener('click', function (e) {
    var help = e.target.closest && e.target.closest('.ce-sp-help');
    if (help) { e.preventDefault(); e.stopPropagation(); SP.showModal(); return; }
    var close = e.target.closest && e.target.closest('.ce-sp-modal-close');
    if (close) { var m = document.getElementById('ce-sp-modal'); if (m) m.remove(); return; }
    if (e.target.id === 'ce-sp-modal') { e.target.remove(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var m = document.getElementById('ce-sp-modal'); if (m) m.remove(); } });

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'ce-sp-checkbox' || SP.busy) return;
    var checked = e.target.checked;
    SP.setOptOut(!checked);
    SP.busy = true;
    SP.getCart().then(function (c) {
      SP.lastCart = c;
      if (checked) { if (!SP.protIn(c)) return SP.add(SP.variants[SP.feeForCart(SP.subtotalNoProt(c))]); }
      else { return SP.removeAll(c); }
    }).then(function () { return SP.getCart(); })
      .then(function (c2) { SP.lastCart = c2; SP.syncRow(); SP.notify(c2); })
      .finally(function () { SP.busy = false; });
  });

  // auto-add (pre-check) on any cart mutation, wherever it came from
  var cuDeb;
  document.addEventListener('cart:update', function (e) {
    var src = e.detail && e.detail.sourceId;
    if (src === 'ce-sp') return;
    clearTimeout(cuDeb);
    cuDeb = setTimeout(function () { SP.refresh(true); }, 500);
  });

  // auto-add (pre-check) shortly after an add-to-cart
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-add-to-cart], .add-to-cart, [name="add"], add-to-cart-component button, .product-form__submit')) {
      SP.lastAdd = Date.now();
      setTimeout(function () { SP.refresh(true); }, 1200);
      setTimeout(function () { SP.refresh(true); }, 2500);
    }
  });

  // re-inject whenever the drawer (or anything) re-renders
  var deb;
  var mo = new MutationObserver(function () {
    clearTimeout(deb);
    deb = setTimeout(function () { if (SP.busy) return; if (!SP.lastCart) { SP.refresh(false); return; } SP.ensureUI(); SP.syncRow(); }, 200);
  });
  try { mo.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}

  function boot() { SP.refresh(true); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  setInterval(function () { if (!document.hidden) SP.reconcile(); }, 4000);
})();
